/*
 * @Author: Teemo Ding
 * @Date: 2021-12-14 15:46:40
 * @LastEditTime: 2022-01-12 14:55:05
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/shoppingCartTemplate.ts
 */
import { post, get, remove } from 'src/tools/server';
export const applyShoppingCartTemplate = (data, params = {}) => {
  return post<any>(`/portal/order/shoppingCartTemplate/apply`, data, {
    ...params,
  });
};
export const saveShoppingCartTemplate = (data, params = {}) => {
  return post<any>(`/portal/order/shoppingCartTemplate`, data, {
    ...params,
  });
};

export const getShoppingCartTemplate = (shoppingCartTemplateUuid) => {
  return get<any>(`/portal/order/shoppingCartTemplatePage`, {
    params: { shoppingCartTemplateUuid },
  });
};

export const activeShoppingCartTemplate = (shoppingCartTemplateUuid) => {
  return post<any>(
    `/portal/order/shoppingCartTemplate/${shoppingCartTemplateUuid}/activate`,
    {},
    {},
  );
};
export const notifyShoppingCartTemplate = (data, params = {}) => {
  return post<any>(`/portal/order/shoppingCartTemplate/notify`, data, {
    ...params,
  });
};

export const deleteShoppingCartTemplate = (
  shoppingCartTemplateUuid,
  params = {},
) => {
  return remove<any>(
    `/portal/order/shoppingCartTemplate/${shoppingCartTemplateUuid}`,
    { ...params },
  );
};
